import React, { useState } from 'react';
import { ExternalLink } from 'lucide-react';

const LEBONCOIN_URL = 'https://www.leboncoin.fr/boutique/38838/bouhdel_constructeur_de_maisons_individuelles.htm';
const SELOGER_URL = 'https://www.seloger.com/professionnels-immobilier/Toi3oStRyiSr5KoBdWfXWD';

const droneImages = [
  '/assets/photos/drone/DJI_0043.webp',
  '/assets/photos/drone/DJI_0046.webp',
  '/assets/photos/drone/DJI_0143.webp',
];

const TerrainsOffers = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  React.useEffect(() => {
    const timer = setInterval(
      () => setCurrentSlide((prev) => (prev + 1) % droneImages.length),
      5000
    );
    return () => clearInterval(timer);
  }, []);

  return (
    <section id="offres-terrains" className="lbc-section">
      {/* ── Drone carousel background ── */}
      <div className="lbc-bg">
        {droneImages.map((img, i) => (
          <div
            key={i}
            className={`lbc-bg-slide ${i === currentSlide ? 'lbc-bg-slide--active' : ''}`}
          >
            <img src={img} alt="" className="lbc-bg-img" />
          </div>
        ))}
        <div className="lbc-bg-overlay" />
      </div>

      {/* carousel dots */}
      <div className="lbc-dots">
        {droneImages.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrentSlide(i)}
            className={`lbc-dot ${i === currentSlide ? 'lbc-dot--active' : ''}`}
            aria-label={`Photo aérienne ${i + 1} sur ${droneImages.length}`}
          />
        ))}
      </div>

      {/* ── Content ── */}
      <div className="container lbc-inner">
        <div className="lbc-redirect-wrapper" data-aos="fade-up">

          <h2 className="section-title">Offres terrain&nbsp;+&nbsp;maison</h2>
          <p className="section-subtitle">
            Retrouvez toutes nos offres terrain&nbsp;+&nbsp;maison disponibles
            directement sur notre boutique LeBonCoin.
          </p>

          {/* CTA buttons row */}
          <div className="lbc-redirect-ctas-row">
            {/* CTA principal LeBonCoin */}
            <a
              href={LEBONCOIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="lbc-redirect-cta"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <div className="lbc-redirect-cta-logo">
                <span className="lbc-strip-logo-text">leboncoin</span>
              </div>
              <span className="lbc-redirect-cta-label">
                Voir toutes nos annonces
              </span>
              <ExternalLink size={20} className="lbc-redirect-cta-icon" />
            </a>

            {/* CTA SeLoger */}
            <a
              href={SELOGER_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="lbc-redirect-cta seloger-cta"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="lbc-redirect-cta-logo">
                <span className="lbc-strip-logo-text seloger-logo-text">SeLoger</span>
              </div>
              <span className="lbc-redirect-cta-label">
                Notre vitrine SeLoger
              </span>
              <ExternalLink size={20} className="lbc-redirect-cta-icon" />
            </a>
          </div>

          <p className="lbc-cta-note">Retrouvez nos offres sur leboncoin.fr et seloger.com</p>
        </div>

        {/* Vous avez un terrain ? */}
        <div className="lbc-secondary-cta" data-aos="fade-up" data-aos-delay="150">
          <div className="lbc-secondary-cta-inner">
            <div className="lbc-secondary-cta-text">
              <h4>Vous avez déjà un terrain&nbsp;?</h4>
              <p>Nous construisons votre maison 100&nbsp;% personnalisable sur votre terrain.</p>
            </div>
            <div className="lbc-secondary-cta-btns">
              <a href="#contact" className="btn-primary">Étude gratuite</a>
              <a href="#agences" className="btn-secondary">RDV en agence</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TerrainsOffers;
